// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.osdLBHg9JMjXsmfsLnC1 {
	font-family: 'Cygnito Mono', monospace;
	font-weight: 500;
	margin: 0;
	color: #17181b;

	/* Sizes */
}
.osdLBHg9JMjXsmfsLnC1.eEqEwDhWcWpFBw4QVSzV {
		font-size: 16px;
		line-height: 24px;
	}
.osdLBHg9JMjXsmfsLnC1.iwXWCb63UU_fskNDWtms {
		font-size: 14px;
		line-height: 24px;
	}
.osdLBHg9JMjXsmfsLnC1.Qf1HEMbpaBmsk8Q3xO04 {
		font-size: 12px;
		line-height: 20px;
	}
.osdLBHg9JMjXsmfsLnC1.aKiMn92GD5fMN7uUvIC9 {
		font-size: 10px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 1px;
	}

/* Colors */
.osdLBHg9JMjXsmfsLnC1.MT9fbUkCJIMhnUIngIcX {
		color: #9ca6b4;
	}
.osdLBHg9JMjXsmfsLnC1.aC52gHYKqlCx_1xdb5DA {
		color: #ff8d24;
	}
.osdLBHg9JMjXsmfsLnC1.f06lRqPnwY2XEvAHbFeW {
		color: #29c34a;
	}
.osdLBHg9JMjXsmfsLnC1.D0QolD9iY_Fjdbea7DLy {
		color: #2097f6;
	}
.osdLBHg9JMjXsmfsLnC1.zGy9U6Wg_oUXiE5vDOOW {
		color: #fd4040;
	}
.osdLBHg9JMjXsmfsLnC1.MEh39a8XCehqLdsQjCP9 {
		color: inherit;
	}

/* Weight */
.osdLBHg9JMjXsmfsLnC1.E0HeSWcs5jbQJpHHBDIX {
		font-weight: 600;
	}
`, "",{"version":3,"sources":["webpack://./src/components/Text/Text.pcss"],"names":[],"mappings":"AAAA;CACC,sCAAsC;CACtC,gBAAgB;CAChB,SAAS;CACT,cAAc;;CAEd,UAAU;AAoDX;AAnDC;EACC,eAAe;EACf,iBAAiB;CAClB;AAEA;EACC,eAAe;EACf,iBAAiB;CAClB;AAEA;EACC,eAAe;EACf,iBAAiB;CAClB;AAEA;EACC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;CACpB;;AAEA,WAAW;AACX;EACC,cAAc;CACf;AAEA;EACC,cAAc;CACf;AAEA;EACC,cAAc;CACf;AAEA;EACC,cAAc;CACf;AAEA;EACC,cAAc;CACf;AAEA;EACC,cAAc;CACf;;AAEA,WAAW;AACX;EACC,gBAAgB;CACjB","sourcesContent":[".text {\n\tfont-family: 'Cygnito Mono', monospace;\n\tfont-weight: 500;\n\tmargin: 0;\n\tcolor: #17181b;\n\n\t/* Sizes */\n\t&.L {\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t}\n\n\t&.M {\n\t\tfont-size: 14px;\n\t\tline-height: 24px;\n\t}\n\n\t&.S {\n\t\tfont-size: 12px;\n\t\tline-height: 20px;\n\t}\n\n\t&.CAPTION {\n\t\tfont-size: 10px;\n\t\tfont-weight: 600;\n\t\tline-height: 20px;\n\t\tletter-spacing: 1px;\n\t}\n\n\t/* Colors */\n\t&.secondary {\n\t\tcolor: #9ca6b4;\n\t}\n\n\t&.warning {\n\t\tcolor: #ff8d24;\n\t}\n\n\t&.success {\n\t\tcolor: #29c34a;\n\t}\n\n\t&.link {\n\t\tcolor: #2097f6;\n\t}\n\n\t&.danger {\n\t\tcolor: #fd4040;\n\t}\n\n\t&.inherit {\n\t\tcolor: inherit;\n\t}\n\n\t/* Weight */\n\t&.bold {\n\t\tfont-weight: 600;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `osdLBHg9JMjXsmfsLnC1`,
	"L": `eEqEwDhWcWpFBw4QVSzV`,
	"l": `eEqEwDhWcWpFBw4QVSzV`,
	"M": `iwXWCb63UU_fskNDWtms`,
	"m": `iwXWCb63UU_fskNDWtms`,
	"S": `Qf1HEMbpaBmsk8Q3xO04`,
	"s": `Qf1HEMbpaBmsk8Q3xO04`,
	"CAPTION": `aKiMn92GD5fMN7uUvIC9`,
	"caption": `aKiMn92GD5fMN7uUvIC9`,
	"secondary": `MT9fbUkCJIMhnUIngIcX`,
	"warning": `aC52gHYKqlCx_1xdb5DA`,
	"success": `f06lRqPnwY2XEvAHbFeW`,
	"link": `D0QolD9iY_Fjdbea7DLy`,
	"danger": `zGy9U6Wg_oUXiE5vDOOW`,
	"inherit": `MEh39a8XCehqLdsQjCP9`,
	"bold": `E0HeSWcs5jbQJpHHBDIX`
};
export default ___CSS_LOADER_EXPORT___;
